import type { AssetLibraryDisplayItem } from './utils';

export type AssetLibraryMediaKind = 'media-image' | 'media-video';

export type AssetLibraryMediaSelection = {
  kind: AssetLibraryMediaKind;
  mediaID: string;
  assetID: string;
  label: string;
  thumbnailURL: string | null;
};

export function toAssetLibraryMediaSelection(
  asset: AssetLibraryDisplayItem,
): AssetLibraryMediaSelection | null {
  if (asset.assetType === 'MEDIA_IMAGE') {
    return {
      kind: 'media-image',
      mediaID: asset.assetID,
      assetID: asset.assetID,
      label: asset.assetName,
      thumbnailURL: asset.thumbnailURL,
    };
  }

  if (asset.assetType === 'MEDIA_VIDEO') {
    return {
      kind: 'media-video',
      mediaID: asset.assetID,
      assetID: asset.assetID,
      label: asset.assetName,
      thumbnailURL: asset.thumbnailURL,
    };
  }

  return null;
}

export function getMediaPickerTitleSuffix(
  mediaKind: 'image' | 'video',
): string {
  return mediaKind === 'video' ? ' (videos)' : ' (images)';
}

export function getMediaPickerConfirmLabel(input: {
  mediaKind: 'image' | 'video';
  count: number;
}): string {
  const noun = input.mediaKind === 'video' ? 'video' : 'image';
  const plural = input.count === 1 ? noun : `${noun}s`;
  return `Add ${plural} (${input.count})`;
}
